<template>
  <v-btn color="primary" elevation="0" @click="() => handleOpenCreateUpdateServiceProviderModal()">
    <v-icon left>mdi-plus</v-icon>
    <span class="d-none d-md-flex body-2">
      {{ $t('serviceProviders.action.createVendors') }}
    </span>
  </v-btn>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'HausefulUsersHeaderActions',

  methods: {
    ...mapActions(['handleOpenCreateUpdateServiceProviderModal']),
  },
}
</script>
